import React, {useMemo, useEffect, useState} from 'react'
import { ReviewRow, ReviewMediaRow } from '../ReviewRow/ReviewRow'
import { ButtonIcon } from 'pepsico-ds'
import { ReviewProductsTable } from '@/components/organisms'
import { useInfiniteScrollTable } from '@/hooks/useInfiniteScrollTable'
import { API_STATUS } from '@/utils/constants/commonConstants'
import { isPublished } from '@/utils/commons'
import { downloadCSVFiles } from '@/helpers/shadcn/utils'
import { useParams, useSearchParams } from 'react-router-dom'

const getAnswer = val => (val ? 'Yes' : 'No')

const LanguageContent = ({lang, selectedTab, displayContent}) => {
  const data = useMemo(
    () => (selectedTab === 'parent' ? displayContent?.[lang.code] : displayContent?.child?.[lang.code]),
    [lang.code, selectedTab, displayContent]
  )

  if (!data) return null

  return (
    <>
      <ReviewRow data-testid="display-title-label" label="Title" value={data.title} />
      <ReviewRow data-testid="display-category-title-label" label="Category for Target Title" value={data?.category} />
      <ReviewRow label="Excerpt" value={data.excerpt} />
      <ReviewRow label="Terms" value={data.terms} />
    </>
  )
}

const DisplayContent = ({displayContentMedia, languages, selectedTab, displayContent}) => {
  const imageUri = useMemo(
    () => displayContentMedia?.imageUri || displayContentMedia?.imageUrl || '',
    [displayContentMedia]
  )

  return (
    <div data-testid="ReviewParentChildContent">
      <div className="review_subtitle mtb30">Display</div>
      {languages?.map(lang => (
        <div className="grid" key={lang.code}>
          <div className="grid_wrap">
            <div className="review_grid_row borderBottom0 grid-col-temp grid grid-cols-2 gap-y-2">
              <div className="rev_lang">
                <span>Language: </span> <span className="langBold">{lang.title}</span>
              </div>
            </div>
            <LanguageContent lang={lang} selectedTab={selectedTab} displayContent={displayContent}/>
          </div>
        </div>
      ))}

      {imageUri && imageUri !== '' && (
        <>
          <div className="review_subtitle mtb16">Media</div>
          <div className="grid grid-cols-2">
            <div className="grid_wrap">
              <a
                href={imageUri}
                download={'display_content_image.png'}
                className="review_image_row grid cursor-pointer grid-cols-2 gap-y-2"
              >
                <img src={imageUri} alt="Pepsi Logo" />
              </a>
              <ReviewMediaRow data-testid="display-title-label" label="Title" value={displayContentMedia?.title} />
              <ReviewMediaRow label="Opt In" value={getAnswer(displayContentMedia?.optIn)} />
              <ReviewMediaRow label="Image Id" value={displayContentMedia?.imageId} />
            </div>
          </div>
        </>
      )}
    </div>
  )
}
const ProductUploadedFile = ({selectedTab,salesTargetData,preRequisiteActiveParentTab,preRequisiteActiveChildTab,getSelectedCategoryTitle = () => { },parentTableData,childTableData}) => {

  const onDownloadClick = async () => {
  let rule;
  let mediaFile;

  if (selectedTab === 'parent') {
    rule = salesTargetData?.tabWiseData?.parent?.ruleSet?.rules?.[0]
      || salesTargetData?.ruleSet?.rules?.[0];
    mediaFile = salesTargetData?.tabWiseData?.parent?.mediaFile?.[0];
  } else if (selectedTab === 'child') {
    rule = salesTargetData?.tabWiseData?.child?.ruleSet?.rules?.[0]
      || salesTargetData?.ruleSet?.rules?.[0];
    mediaFile = salesTargetData?.tabWiseData?.child?.mediaFile?.[0];
  } else {
    rule = salesTargetData?.ruleSet?.rules?.[0];
    mediaFile = salesTargetData?.mediaFile?.[0];
  }

  const includedProductIds = rule?.includedProductIds || [];
    if (!includedProductIds.length) return; // Prevent download if empty
    const csvHeader = 'Product Id\n';
    const csvRows = includedProductIds.join('\n');
    const csvString = csvHeader + csvRows;
    downloadCSVFiles(csvString, mediaFile);
  };
  return (
    <>
      <div className="review_subtitle">Target Setup</div>
      {selectedTab === 'parent' ? <>
        {preRequisiteActiveParentTab?.categoryTable && (
          <>
          <div className="grid grid-cols-2 gap-8">
          <div className="grid grid-cols-1 ">
            <div className="grid_wrap">
              <div className="review_grid_row grid grid-cols-2 gap-y-2">
                <div className="review_title">
                  <span>Ignore SKU List</span>
                </div>
                <div className="review_value text-white">
                  <span>{getAnswer(salesTargetData?.tabWiseData?.parent?.ignoreSkuList)}</span>
                </div>
              </div>
              <div className="review_grid_row grid grid-cols-2 gap-y-2">
                <div className="review_title">
                  <span>Product Selection</span>
                </div>
                <div className="review_value text-white">
                  <span>
                  {salesTargetData?.tabWiseData?.parent?.includedProducts?.length > 0 ||
        salesTargetData?.tabWiseData?.parent?.excludedProducts?.length > 0 ? 'CURRENT LIST' : '-'}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 ">
            <div className="grid_wrap">
              <div className="review_grid_row grid grid-cols-2 gap-y-2">
                <div className="review_title">
                  <span>Category</span>
                </div>
                <div className="review_value text-white">
                  <span>{getSelectedCategoryTitle()}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
          <ReviewProductsTable
            displayedProducts={parentTableData.displayedProducts}
            isLoading={parentTableData.isLoading}
            hasMoreData={parentTableData.hasMoreData}
            totalProducts={parentTableData.totalProducts}
            onScroll={parentTableData.handleScroll}
            containerRef={parentTableData.tableContainerRef}
            itemsPerPage={parentTableData.itemsPerPage}
          />
          </>
        )}
        {preRequisiteActiveParentTab?.uploadFile && (
          <div className="grid">
            <div className="grid_wrap flex flex-direction-row">
              <ReviewRow label="Product List" value={salesTargetData?.tabWiseData?.parent?.mediaFile[0]} />
              <ButtonIcon
                icon="file_download"
                isDark
                onClick={onDownloadClick}
                size="medium"
                type="default"
                data-testid="file_download"
              />
            </div>
          </div>
        )}
      </> : <>
        {preRequisiteActiveChildTab?.categoryTable && (
          <>
           <div className="grid grid-cols-2 gap-8">
          <div className="grid grid-cols-1 ">
            <div className="grid_wrap">
              <div className="review_grid_row grid grid-cols-2 gap-y-2">
                <div className="review_title">
                  <span>Ignore SKU List</span>
                </div>
                <div className="review_value text-white">
                  <span>{getAnswer(salesTargetData?.tabWiseData?.child?.ignoreSkuList)}</span>
                </div>
              </div>
              <div className="review_grid_row grid grid-cols-2 gap-y-2">
                <div className="review_title">
                  <span>Product Selection</span>
                </div>
                <div className="review_value text-white">
                  <span>
                    {salesTargetData?.tabWiseData?.child?.includedProducts?.length > 0 ||
        salesTargetData?.tabWiseData?.child?.excludedProducts?.length > 0 ? 'CURRENT LIST' : '-'}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 ">
            <div className="grid_wrap">
              <div className="review_grid_row grid grid-cols-2 gap-y-2">
                <div className="review_title">
                  <span>Category</span>
                </div>
                <div className="review_value text-white">
                  <span>{getSelectedCategoryTitle()}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
          <ReviewProductsTable
            displayedProducts={childTableData.displayedProducts}
            isLoading={childTableData.isLoading}
            hasMoreData={childTableData.hasMoreData}
            totalProducts={childTableData.totalProducts}
            onScroll={childTableData.handleScroll}
            containerRef={childTableData.tableContainerRef}
            itemsPerPage={childTableData.itemsPerPage}
          />
          </>
        )}
        {preRequisiteActiveChildTab?.uploadFile && (
          <div className="grid">
            <div className="grid_wrap grid_wrap flex flex-direction-row">
              <ReviewRow label="Product List" value={salesTargetData?.tabWiseData?.child?.mediaFile[0]} />
              <div
                className='grid_wrap review_grid_row'
              >
                <ButtonIcon
                  icon="file_download"
                  isDark
                  onClick={onDownloadClick}
                  size="medium"
                  type="default"
                  data-testid="file_download"
                />
              </div>
            </div>
          </div>
        )}
      </>}
    </>
  )
}

const ReviewParentChildTab = ({ languages, salesTargetData, selectedTab, section, preRequisiteParentTabData, preRequisiteChildTabData, getFilteredProducts, getSelectedCategoryTitle = () => { } }) => {
  const { displayContent, displayContentMedia, preRequisiteParentTab, preRequisiteChildTab } = salesTargetData;

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const urlStatus = searchParams.get('status');

  const [preRequisiteActiveParentTab, setPreRequisiteActiveParentTab] = useState(null);
  const [preRequisiteActiveChildTab, setPreRequisiteActiveChildTab] = useState(null);

  const parentProducts = useMemo(() => getFilteredProducts ? getFilteredProducts('parent') : [], [getFilteredProducts]);
  const childProducts = useMemo(() => getFilteredProducts ? getFilteredProducts('child') : [], [getFilteredProducts]);

  const parentTableData = useInfiniteScrollTable(parentProducts);
  const childTableData = useInfiniteScrollTable(childProducts);

  useEffect(() => {
    if (urlStatus?.toLowerCase() === API_STATUS.DRAFT?.toLowerCase() || isPublished(urlStatus)) {
      setPreRequisiteActiveParentTab(preRequisiteParentTabData)
      setPreRequisiteActiveChildTab(preRequisiteChildTabData);
    } else {
      setPreRequisiteActiveParentTab(preRequisiteParentTab);
      setPreRequisiteActiveChildTab(preRequisiteChildTab);
    }
  }, [urlStatus, id, preRequisiteParentTabData, preRequisiteChildTabData, preRequisiteParentTab, preRequisiteChildTab]);

  return (
    <>
      {section === 'display-content' ? (
        <DisplayContent
          displayContentMedia={displayContentMedia}
          languages={languages}
          selectedTab={selectedTab}
          displayContent={displayContent}
        />
      ) : (
        <ProductUploadedFile
          selectedTab={selectedTab}
          salesTargetData={salesTargetData}
          preRequisiteActiveParentTab={preRequisiteActiveParentTab}
          preRequisiteActiveChildTab={preRequisiteActiveChildTab}
          getSelectedCategoryTitle={getSelectedCategoryTitle}
          parentTableData={parentTableData}
          childTableData={childTableData}
        />
      )}
    </>
  )
}

export default React.memo(ReviewParentChildTab)
